import axios from "axios";
import config from "../config";

export const getMeta = async () => {
  try {
    const response = await axios({
      method: "get",
      url: `${config.SERVER_URL}/metas/`,
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};